import React, { Component } from "react"
import styled from "styled-components"
import Highcharts from "highcharts"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import NineBoxGridDrilldownScorePairShape from "../../../state/shapes/NineBoxGridDrilldownScorePairShape"
import { CHARTS } from "../../../constants"
import { formatNumberForDisplay } from "../../../utils/formatting-utils"

const RecentScore = styled.p`
  margin-bottom: 0px;
  color: black;
  font-size: 14px;
  text-align: center;
`

class AreaChart extends Component {
  componentDidMount = () => {
    const {
      chartHeight, chartWidth, yMinValue, yMaxValue, data, t, showPercentage,
    } = this.props

    // Create seriesData from input data
    const seriesData = data.map((item) => {
      return {
        y: item.score,
        date: new Date(item.date).toLocaleDateString(),
        text: item.text,
      }
    })

    // Get the element into which to insert the chart
    const chartContainer = this.chartContainerRef

    if (data.length > 0) {
      // Create the chart
      this.chart = new Highcharts.Chart({
        chart: {
          renderTo: chartContainer,
          height: chartHeight,
          width: chartWidth,
          type: "area",
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          animation: CHARTS.animationEnabled,
        },
        lang: {
          contextButtonTitle: t("Common.ChartDownloadOptions"),
        },
        title: {
          text: "",
        },
        xAxis: {
          allowDecimals: false,
          labels: {
            enabled: false,
          },
        },
        yAxis: {
          gridLineColor: "transparent",
          labels: {
            enabled: false,
          },
          title: "",
          min: yMinValue,
          max: yMaxValue,
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          formatter() {
            if (showPercentage) {
              return `${t("Common.Scored")} <b>${
                this.point.y === 0 ? this.point.y : formatNumberForDisplay(Math.round(this.point.y))
              }</b>% ${t("Common.LowerCaseOn")}: ${this.point.date}`
            }
            return `${t("Common.Scored")} <b>${t(this.point.text)}</b> ${t("Common.LowerCaseOn")}: ${this.point.date}`
          },
        },
        plotOptions: {
          area: {
            marker: {
              enabled: false,
              symbol: "circle",
              radius: 2,
              states: {
                hover: {
                  enabled: true,
                },
              },
            },
          },
        },
        series: [
          {
            name: "",
            data: seriesData,
            showInLegend: false,
          },
        ],
        exporting: { enabled: false },
      })
    }
  }

  componentWillUnmount = () => {
    if (this.props.data.length > 0) {
      this.chart.destroy()
    }
  }

  render() {
    const {
      t, chartWidth, data, showPercentage,
    } = this.props

    return (
      <div>
        {data.length > 0 && (
          <div>
            <div
              className="chart-container col-md-12"
              ref={(c) => {
                this.chartContainerRef = c
              }}
            />
            {data[data.length - 1].score === 0 && (
              <div>
                {showPercentage && (
                  <RecentScore style={{ width: `${chartWidth}px` }}>
                    {t("Common.RecentScore")}: {data[data.length - 1].score}%
                  </RecentScore>
                )}
                {!showPercentage && (
                  <RecentScore style={{ width: `${chartWidth}px` }}>
                    {t("Common.RecentScore")}: {t(data[data.length - 1].text)}
                  </RecentScore>
                )}
              </div>
            )}
            {data[data.length - 1].score !== 0 && (
              <div>
                {showPercentage && (
                  <RecentScore style={{ width: `${chartWidth}px` }}>
                    {t("Common.RecentScore")}:{" "}
                    {formatNumberForDisplay(Math.round(data[data.length - 1].score))}%
                  </RecentScore>
                )}
                {!showPercentage && (
                  <RecentScore style={{ width: `${chartWidth}px` }}>
                    {t("Common.RecentScore")}: {t(data[data.length - 1].text)}
                  </RecentScore>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

AreaChart.propTypes = {
  chartHeight: PropTypes.number,
  chartWidth: PropTypes.number,
  yMinValue: PropTypes.number,
  yMaxValue: PropTypes.number,
  data: PropTypes.arrayOf(PropTypes.shape(NineBoxGridDrilldownScorePairShape)).isRequired,
  showPercentage: PropTypes.bool,
  t: PropTypes.func.isRequired,
}

AreaChart.defaultProps = {
  chartHeight: 100,
  chartWidth: 150,
  yMinValue: 0,
  yMaxValue: 100,
}

export default translate()(AreaChart)



// WEBPACK FOOTER //
// ./src/components/charts/generic/AreaChart.jsx